export default "__VITE_ASSET__CJT8G0WL__"